import { render, staticRenderFns } from "./NodeItem.vue?vue&type=template&id=b2d8943c&scoped=true&"
import script from "./NodeItem.vue?vue&type=script&lang=js&"
export * from "./NodeItem.vue?vue&type=script&lang=js&"
import style0 from "./NodeItem.vue?vue&type=style&index=0&id=b2d8943c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d8943c",
  null
  
)

export default component.exports